
export default {
  name: 'MobileNavigation',
  props: {
    userName: { type: String, default: null }
  },
  data () {
    return {
      open: false
    }
  },
  watch: {
    $route () {
      this.open = false
    },
    '$auth.user.id' () {
      this.open = false
    }
  }
}
